import logo from "../../assets/imgs/logoFsfb_header_blue.svg"
import styles from "./HeaderLogo.module.scss"

export default function HeaderLogo() {
    return (
        <>
        <img src={logo} alt="Logo FSFB" className={styles.logoFsfbHeader}/>
        </>
    )
}